var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebcamEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5V14C17 13.45 16.55 13 16 13H4C3.45 13 3 13.45 3 14V24C3 24.55 3.45 25 4 25H16C16.55 25 17 24.55 17 24V20.5L21 24.5V13.5L17 17.5Z",
    fill: "#5D5E76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1.16675C22.78 1.16675 20.1666 3.78008 20.1666 7.00008C20.1666 10.2201 22.78 12.8334 26 12.8334C29.22 12.8334 31.8333 10.2201 31.8333 7.00008C31.8333 3.78008 29.22 1.16675 26 1.16675ZM26 7.58341C25.6791 7.58341 25.4166 7.32091 25.4166 7.00008V4.66675C25.4166 4.34591 25.6791 4.08341 26 4.08341C26.3208 4.08341 26.5833 4.34591 26.5833 4.66675V7.00008C26.5833 7.32091 26.3208 7.58341 26 7.58341ZM26.5833 9.91675H25.4166V8.75008H26.5833V9.91675Z",
    fill: "#DEDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcamEnabled);
export default __webpack_public_path__ + "static/media/webcam_enabled.a38122be6870ab0f221c60c28e002fad.svg";
export { ForwardRef as ReactComponent };